import React from 'react'
import url from 'libraries/front-end-core/core/url'
import { scrollTo } from 'libraries/front-end-core/helpers/document'
import {
  DASHBOARD
} from 'constants/controllers'
import {
  URL_TERMS_OF_USE,
  URL_TERMS_OF_USE_DOCDRAFTER,
  URL_PRIVACY_POLICY,
  URL_LINKEDIN,
  URL_TRAINING,
  URL_FREE_TRIAL,
  URL_SUPPORT,
  URL_BLOG,
  URL_TEAMS,
  URL_CAREERS,
  URL_SITEMAP,
  URL_FAQ,
  URL_CORPORATE,
  URL_EMPLOYMENT,
  URL_DOCUMENTS,
  URL_USER_GUIDES,
  URL_SECURITY,
  URL_RESTRUCTURING_INSOLVENCY,
  URL_FC_EDUCATION
} from 'constants/links'
import { useSelector } from 'react-redux'
import selectNewsAol from 'redux/selectors/selectNewsAol'
import selectIsIE from 'redux/selectors/selectIsIE'
import cx from 'classnames'
import selectController from 'redux/selectors/selectController'
import logoWhiteAbbrImg from 'images/fc-logo-abbr-white.svg'
import bsiMarkOfTrust from 'images/bsi-mark-of-trust.png'
import Icon from 'components/shared/Icon'
import selectDeviceType from 'redux/selectors/selectDeviceType'
import selectPageId from 'redux/selectors/selectPageId'

const LinkList = ({ title, links = [] }) => {
  const isIE = useSelector(selectIsIE)

  return (
    <div className={cx('basis0 basis-auto-t w-50 w-100-m mb9-t shrink-1 grow-1 mh6 mh0-t', { 'ie-basis0-fix': isIE })}>
      <h3 className='f5 fw6 mt0 mb3'>{title}</h3>
      <ul className='list-reset pa0 mh0 mt0 mb4'>
        {links.map(({ text, href, target = '_self', rel }) => (
          <li key={text} className='mb3 last-child-mb0'>
            <a className='gains-boro no-underline hover-underline f5 wb-word-m ws-normal-m' {...{ href, target, rel }}>{text}</a>
          </li>
        ))}
      </ul>
    </div>
  )
}

const Footer = () => {
  const newsAol = useSelector(selectNewsAol)
  const activePage = useSelector(selectController)
  const activePageIsDashboard = activePage === DASHBOARD
  const { isMobile } = useSelector(selectDeviceType)
  const pageId = useSelector(selectPageId)

  const handleLogoClick = () => {
    if (activePageIsDashboard) {
      scrollTo({ pageId, id: 0, animate: true, useWindowScrollTo: isMobile })
    }
  }
  return (
    <div className='bg-black white pt9 pv9-t ph7-t' id='footer'>
      <div className='layout-width-constraint mb11 mb9-t flex flex-wrap'>
        <div className='flex flex-column mr8'>
          <a
            href={url(DASHBOARD, newsAol ? { aol: newsAol } : {})}
            className='db w-100-t mt3 mb6'
            onClick={handleLogoClick}
            data-event-category='Logo'
            data-event-action='Select'
          >
            <img className='w10' src={logoWhiteAbbrImg} alt='Logo' />
          </a>
          <img className='h5 mb6-m' src={bsiMarkOfTrust} />
        </div>
        <div className='inline-flex flex-wrap justify-between grow-1'>
          <ContactUs />
          <Company />
          <Resources />
          <Products />
          <Community />
        </div>
      </div>
      <div className='tc f6 fw3'>
        &copy;FromCounsel Limited {new Date().getFullYear()}. All rights reserved.
      </div>
    </div>
  )
}

const ContactUs = () => (
  <LinkList
    title='Contact us'
    links={[
      {
        text: 'Get in touch',
        href: URL_FREE_TRIAL,
        target: '_blank',
        rel: 'noopener noreferrer'
      },
      {
        text: 'Request a trial',
        href: URL_FREE_TRIAL,
        target: '_blank',
        rel: 'noopener noreferrer'
      },
      {
        text: 'Support',
        href: URL_SUPPORT,
        target: '_blank',
        rel: 'noopener noreferrer'
      }
    ]}
  />
)

const Resources = () => (
  <LinkList
    title='Resources'
    links={[{
      text: 'User Guides',
      href: URL_USER_GUIDES,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      text: 'Privacy policy',
      href: URL_PRIVACY_POLICY,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      text: 'T&Cs',
      href: URL_TERMS_OF_USE,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      text: 'Document automation T&C',
      href: URL_TERMS_OF_USE_DOCDRAFTER,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      text: 'FAQs',
      href: URL_FAQ,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      text: 'Security',
      hreg: URL_SECURITY,
      target: '_blank',
      rel: 'noopener noreferrer'
    }]}
  />
)

const Products = () => (
  <LinkList
    title='Products & Services'
    links={[{
      text: 'FC Corporate',
      href: URL_CORPORATE,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      text: 'FC R&I',
      href: URL_RESTRUCTURING_INSOLVENCY,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      text: 'FC Employment',
      href: URL_EMPLOYMENT,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      text: 'FC Learning',
      href: URL_TRAINING,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      text: 'FC Documents',
      href: URL_DOCUMENTS,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      text: 'FC Education',
      href: URL_FC_EDUCATION,
      target: '_blank',
      rel: 'noopener noreferrer'
    }]}
  />
)

const Company = () => (
  <LinkList
    title='Company'
    links={[{
      text: 'Blogs',
      href: URL_BLOG,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      text: 'Team',
      href: URL_TEAMS,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      text: 'Careers',
      href: URL_CAREERS,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      text: 'Sitemap',
      href: URL_SITEMAP,
      target: '_blank',
      rel: 'noopener noreferrer'
    }]}
  />
)

const Community = () => {
  const isIE = useSelector(selectIsIE)

  return (
    <div className={cx('basis0 shrink-1 grow-1 basis-auto-t w-50 mb9-t', { 'ie-basis0-fix': isIE })}>
      <h3 className='f5 fw6 mt0 mb4 tc'>Social Media</h3>
      <div className='flex justify-center'>
        <a href={URL_LINKEDIN}>
          <div className='bg-white hover-bg-grey br-100 pa4 flex justify-center items-center mr5'>
            <Icon className='w6 black' name='icon-linkedin' />
          </div>
        </a>
      </div>
    </div>
  )
}

export default Footer
